import { AxiosResponse } from 'axios'

import { Customer } from 'src/types/customer'
import { api } from 'src/utils/api'

export const queryCustomer = (
  customerNumber: number
): Promise<AxiosResponse<Customer>> => api.get(`/klant/${customerNumber}`)
